/**
 * Stats Service - Product view analytics
 */

import { httpClient, HttpError } from '@/lib/http'

// ============================================================================
// TYPES — matches backend ProductViewStatsResponse / HourlyViewStats
// ============================================================================

export interface HourlyViewStats {
  hour: string      // ISO datetime string
  viewCount: number
}

export interface ProductViewStatsResponse {
  productId: number
  totalViews: number
  hourly: HourlyViewStats[]
}

// ============================================================================
// API FUNCTIONS
// ============================================================================

/**
 * Get hourly view statistics for a product
 * GET /products/{id}/stats?from=YYYY-MM-DD&to=YYYY-MM-DD
 * Requires authentication. Available to product owner, team members, and admins.
 */
export async function getProductViewStats(
  slug: string,
  from: string,  // ISO date string (YYYY-MM-DD)
  to: string,    // ISO date string (YYYY-MM-DD)
): Promise<{
  success: boolean
  data?: ProductViewStatsResponse
  error?: { message: string; code?: string }
}> {
  try {
    const response = await httpClient.get<ProductViewStatsResponse>(
      `/products/${slug}/stats`,
      {
        params: { from, to },
      }
    )
    return { success: true, data: response }
  } catch (error) {
    console.error('Failed to fetch product stats:', error)

    if (error instanceof HttpError) {
      return {
        success: false,
        error: {
          message: error.message,
          code: error.code,
        },
      }
    }

    return {
      success: false,
      error: {
        message: 'Не удалось загрузить статистику',
        code: 'UNKNOWN_ERROR',
      },
    }
  }
}
